// extracted by mini-css-extract-plugin
export default {"infoRow":"SeriesIndexOverviewInfoRow-infoRow-BXow2","icon":"SeriesIndexOverviewInfoRow-icon-jEcfh"};